import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  id: 'B1',
  title: 'Las 30 preguntas que toda emprendedora se hace',
  included: 'Pack Pro y Full Access',
  desc: 'Respuestas directas a las dudas del arranque — legal, impositivo y comercial.',
  image: 'https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&w=400&q=55',
  alt: 'Cuaderno con preguntas y respuestas anotadas'
}, {
  id: 'B2',
  title: 'Calculá el precio de cada prenda en 2 minutos',
  included: 'Pack Pro y Full Access',
  desc: 'Planilla lista: ingresás el costo y te da el precio correcto con tu margen.',
  image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=400&q=55',
  alt: 'Calculadora y planilla de cálculo de precios'
}, {
  id: 'B3',
  title: '30 textos listos para publicar en Instagram',
  included: 'Pack Full Access',
  desc: 'Treinta descripciones y llamados a la acción ya escritos para copiar y adaptar.',
  image: 'https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?auto=format&fit=crop&w=400&q=55',
  alt: 'Teléfono mostrando la aplicación de Instagram'
}, {
  id: 'B4',
  title: 'Directorio de proveedores curado',
  included: 'Pack Full Access',
  desc: 'Los mejores mayoristas de Argentina seleccionados con criterio profesional.',
  image: 'https://images.unsplash.com/photo-1567401893414-76b7b1e5a7a5?auto=format&fit=crop&w=400&q=55',
  alt: 'Perchero con ropa en un local mayorista'
}, {
  id: 'B5',
  title: 'Cómo responder consultas y cerrar',
  included: 'Pack Full Access',
  desc: 'Guión exacto para cada situación por DM: precio, "lo pienso", descuento y cambio.',
  image: 'https://images.unsplash.com/photo-1556656793-08538906a9f8?auto=format&fit=crop&w=400&q=55',
  alt: 'Persona respondiendo mensajes en el celular'
}, {
  id: 'B6',
  title: 'Todo lo que necesitás antes de tu primera venta',
  included: 'Pack Full Access',
  desc: 'Checklist de 28 pasos organizados en 5 bloques. Simple, accionable e imprimible.',
  image: 'https://images.unsplash.com/photo-1507925921958-8a62f3d1a50d?auto=format&fit=crop&w=400&q=55',
  alt: 'Lista de verificación con casillas marcadas'
}, {
  id: 'B7',
  title: 'Tu primer shooting con el celular',
  included: 'Pack Full Access',
  desc: 'Fotografiá prendas con luz natural, fondos y encuadres profesionales usando solo el teléfono.',
  image: 'https://images.unsplash.com/photo-1452696193712-6cabf5103b63?auto=format&fit=crop&w=400&q=55',
  alt: 'Celular fotografiando prendas de ropa'
}, {
  id: 'B8',
  title: 'Calendario de contenido: 30 días planificados',
  included: 'Pack Full Access',
  desc: 'Un mes entero de publicaciones para Instagram ya estructurado. Listo para ejecutar.',
  image: 'https://images.unsplash.com/photo-1506784983877-45594efa4cbe?auto=format&fit=crop&w=400&q=55',
  alt: 'Calendario de planificación de contenido'
}];
export function BonusCards() {
  return <section className="w-full py-10 sm:py-20" data-id="element-18">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-8 sm:mb-12" data-id="element-20">
          <p className="text-gold text-xs sm:text-sm tracking-widest mb-3 sm:mb-4" data-id="element-21">
            INCLUIDOS GRATIS
          </p>
          <h2 className="font-display text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-3 sm:mb-4" data-id="element-22">
            8 Bonos Estratégicos
          </h2>
          <p className="text-sm sm:text-base text-violet-100/70" data-id="element-23">
            Sin costo extra — incluidos según el pack elegido
          </p>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5" data-id="element-24">
          {bonuses.map((bonus, index) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index % 4 * 0.05
        }} whileHover={{
          y: -4,
          boxShadow: '0 10px 30px -10px rgba(212, 175, 55, 0.18)'
        }} whileTap={{
          scale: 0.98
        }} className="group bg-violet-deep/60 border border-gold/20 rounded-xl overflow-hidden hover:border-gold/40 transition-colors duration-300 cursor-default flex flex-col" data-id="element-25">
              <div className="relative aspect-[4/3] overflow-hidden" data-id="element-26">
                <img src={bonus.image} alt={bonus.alt} loading="lazy" decoding="async" width={400} height={300} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-27" />
                <div className="absolute inset-0 bg-violet-deep/40" data-id="element-28" />
                <span className="absolute top-2 left-2 bg-violet-deep/80 backdrop-blur-sm text-gold font-bold text-[10px] sm:text-xs px-2 py-0.5 rounded" data-id="element-29">
                  {bonus.id}
                </span>
                <span className="absolute top-2 right-2 bg-green text-white text-[9px] sm:text-[10px] font-bold px-2 py-0.5 rounded" data-id="element-30">
                  GRATIS
                </span>
              </div>

              <div className="p-3 sm:p-4 flex flex-col flex-1" data-id="element-31">
                <h3 className="font-semibold text-white text-xs sm:text-sm leading-snug mb-1 line-clamp-2" data-id="element-32">
                  {bonus.title}
                </h3>
                <p className="text-[9px] sm:text-[10px] text-gold/70 mb-1.5" data-id="element-33">
                  {bonus.included}
                </p>
                <p className="text-[10px] sm:text-xs text-violet-100/70 leading-snug line-clamp-3" data-id="element-34">
                  {bonus.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="text-center text-lg sm:text-2xl font-display font-semibold text-gold mt-8 sm:mt-12" data-id="element-35">
          VALOR TOTAL DE LOS BONOS: $56.000 — GRATIS según tu pack
        </motion.p>
      </div>
    </section>;
}